export default __webpack_public_path__ + "static/media/marutisuzuki.37d97018.webp";